<template>
  <div class="hc-gallery" data-testid="hc-gallery-root">
    <div class="hc-gallery__grid" :style="gridStyle">
      <figure
        v-for="(image, index) in images"
        :key="index"
        class="hc-gallery__item"
        :data-testid="`hc-gallery-item-${index}`"
      >
        <img
          class="hc-gallery__image"
          :src="image.src"
          :alt="image.alt"
          loading="lazy"
          :role="lightboxEnabled ? 'button' : null"
          :tabindex="lightboxEnabled ? '0' : null"
          @click="openLightbox(index)"
          @keydown.enter="openLightbox(index)"
        />
        <figcaption v-if="image.caption" class="hc-gallery__caption">
          {{ image.caption }}
        </figcaption>
      </figure>
    </div>

    <div
      v-if="activeIndex !== null"
      class="hc-gallery__lightbox"
      data-testid="hc-gallery-lightbox"
      role="dialog"
      aria-modal="true"
      @click="closeLightbox"
    >
      <button
        type="button"
        class="hc-gallery__lightbox-close"
        aria-label="Close"
        @click="closeLightbox"
      >
        &times;
      </button>
      <img
        class="hc-gallery__lightbox-image"
        :src="images[activeIndex].src"
        :alt="images[activeIndex].alt"
        @click.stop
      />
    </div>
  </div>
</template>

<script>
import { safeUrl } from '../../blockConfig';

// Responsive image grid with an optional lightbox. Column count is clamped to a
// safe range; every src is URL-validated so no unsafe scheme reaches the DOM.
const MIN_COLUMNS = 1;
const MAX_COLUMNS = 6;

export default {
  name: 'GalleryBlock',
  props: {
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return { activeIndex: null };
  },
  computed: {
    images() {
      const images = this.config && this.config.images;
      if (!Array.isArray(images)) return [];
      return images
        .map(image => ({
          src: safeUrl(image.src),
          alt: image.alt || '',
          caption: image.caption || '',
        }))
        .filter(image => image.src);
    },
    lightboxEnabled() {
      return this.config.lightbox !== false;
    },
    columns() {
      const columns = Number(this.config.columns);
      if (!Number.isFinite(columns)) return 3;
      return Math.min(Math.max(Math.round(columns), MIN_COLUMNS), MAX_COLUMNS);
    },
    gridStyle() {
      return { '--hc-gallery-columns': this.columns };
    },
  },
  methods: {
    openLightbox(index) {
      if (this.lightboxEnabled) this.activeIndex = index;
    },
    closeLightbox() {
      this.activeIndex = null;
    },
  },
};
</script>

<style src="./styles/GalleryBlock.scss" lang="scss" scoped></style>
